export const msalConfig = {
  auth: {
    clientId: "3d39783e-912b-48d4-982d-65614ae17764",
    authority: "https://login.microsoftonline.com/organizations",
  },
};
